module.exports = __webpack_public_path__ + "img/appicon.10d3c628.svg";